<template>
  <div class="top">
    <div class="head">
      <img src="../assets/images/home/logo.png" />
      <div class="tit">
        <div>工程建设全生命周期的</div>
        数字施工与智慧建造
      </div>
      <div class="menu">
        <div
          class="mes"
          v-for="item in menuList"
          :key="item.id"
          @mouseover="over"
          @mouseout="out"
        >
          <a
            :class="idx === item.id ? 'active' : ''"
            @click="menuClick(item.id, item.url)"
            >{{ item.menu }}</a
          >
          <div class="detail">
            <ul>
              <li
                v-for="(child, index) in item.childList"
                :key="index"
                @click="childClick(child.urls, index, item.id)"
              >
                {{ child.name }}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="phone"><i class="el-icon-phone"></i>：0755-88845187</div>
    </div>
    <div class="detail" id="detail"></div>
  </div>
</template>

<script>
export default {
  name: 'Header',
  data() {
    return {
      idx: '',
      menuList: [
        { id: '0', menu: '首页', url: 'home', childList: [] },
        {
          id: '1',
          menu: '关于九象',
          url: 'introduction',
          childList: [
            { name: '公司简介', urls: 'introduction' },
            { name: '发展历程', urls: 'introduction' },
            { name: '发展态势', urls: 'introduction' },
            { name: '发展目标', urls: 'introduction' },
            { name: '企业使命', urls: 'introduction' },
            { name: '新闻中心', urls: 'introduction' },
            { name: '荣誉资质', urls: 'introduction' },
          ],
        },
        {
          id: '2',
          menu: '产品中心',
          url: 'productSite',
          childList: [
            { name: '智慧工地', urls: 'productSite' },
            { name: '智慧安全', urls: 'productSafety' },
            { name: '工程动画', urls: 'productCartoon' },
          ],
        },
        {
          id: '3',
          menu: '解决方案',
          url: 'live',
          childList: [
            { name: '智慧住建', urls: 'live' },
            { name: '智慧工地', urls: 'site' },
            { name: '智慧安全', urls: 'schemeSafety' },
            { name: '工程动画', urls: 'schemeCartoon' },
            { name: '项目展厅展馆', urls: 'schemeShowRoom' },
          ],
        },
        {
          id: '4',
          menu: '应用案例',
          url: 'witSite',
          childList: [
            { name: '智慧工地', urls: 'witSite' },
            { name: '智慧安全', urls: 'applySafety' },
            { name: '工程动画', urls: 'applyCartoon' },
          ],
        },
        {
          id: '5',
          menu: '联系我们',
          url: 'contact',
          childList: [
            { name: '联系方式', urls: 'contact' },
            // {name: '招贤纳士', urls: 'contact'}
          ],
        },
      ],
    }
  },
  methods: {
    childClick(url, code, id) {
      document.documentElement.scrollTop = 0

      //this.$router.push({name: url, params: {key: code + 1}});
      this.$router.push({ name: 'empty', params: { url: url, key: code + 1 } })
      if (this.idx !== id) {
        this.idx = id
        sessionStorage.setItem('idx', id)
      }
      //else {
      //     this.$emit('change', code + 1);
      // }
    },
    menuClick: function (id, url) {
      document.documentElement.scrollTop = 0

      this.idx = id
      this.$router.push(url)
      sessionStorage.setItem('idx', id)
    },
    over(e) {
      if (
        e.currentTarget.lastElementChild.firstElementChild.firstElementChild
      ) {
        document.getElementById('detail').style.display = 'block'
        e.currentTarget.classList.add('active')
      }
    },
    out(e) {
      document.getElementById('detail').style.display = 'none'
      e.currentTarget.classList.remove('active')
    },
  },
  created() {
    sessionStorage.setItem('idx', this.$route.meta.index)
    this.idx = sessionStorage.getItem('idx')
    setInterval(() => {
      if (this.idx !== sessionStorage.getItem('idx')) {
        this.idx = sessionStorage.getItem('idx')
      }
    }, 100)
  },
}
</script>

<style lang="scss" scoped>
.top {
  position: fixed;
  height: 0.8rem;
  width: 100%;
  top: 0;
  background: #fff;
  z-index: 9999;
}

.head {
  width: 16rem;
  height: 0.8rem;
  margin: 0 auto;
  display: flex;

  img {
    margin-top: 0.23rem;
    width: 0.91rem;
    height: 0.38rem;
  }

  .tit {
    line-height: 0.22rem;
    font-size: 0.16rem;
    border-left: 1px solid #e5e5e5;
    margin: 0.2rem 0 0 0.18rem;
    padding-left: 0.18rem;
    height: 0.38rem;
    width: 2.96rem;

    div {
      font-size: 0.14rem;
    }
  }

  .menu {
    display: flex;
    font-size: 0.2rem;

    .mes {
      width: 1.4rem;
      line-height: 0.8rem;
      text-align: center;
      position: relative;

      a {
        width: 100%;
        height: 100%;
        display: inline-block;
      }

      a:hover {
        background: #e70f20;
        color: #fff;
        cursor: pointer;
      }

      .detail {
        left: -0rem;
        z-index: 999;
        background: none;
      }
    }

    .active {
      background: #e70f20;
      color: #fff;
    }

    .mes:hover {
      .detail {
        display: block;
      }
    }

    .wid {
      width: 1rem;
    }
  }

  .phone {
    line-height: 0.8rem;
    margin-left: 0.4rem;
    color: #e71120;
  }
}

div.detail {
  position: absolute;
  height: 0.5rem;
  line-height: 0.5rem;
  width: 100%;
  background: rgba(0, 0, 0, 0.7);
  z-index: 99;
  display: none;

  ul {
    margin: 0 auto;
    background: red;
    width: 12rem;
    color: #fff;

    li {
      list-style: none;
      float: left;
      padding: 0 0.2rem;
      color: #c7c7c7;
      cursor: pointer;
    }

    li:hover {
      color: #fff;
    }
  }
}

.wechat {
  cursor: pointer;
  display: inline-block;
  position: relative;

  &:hover {
    img {
      display: inline-block;
    }
  }

  img {
    position: absolute;
    width: 200px;
    height: 200px;
    left: -50px;
    top: 0;
    display: none;
  }
}
</style>
